import React from 'react';
import { useTranslation } from 'react-i18next';
import { Meter, Text } from "@react-spectrum/s2";
import { formatCount } from '../../utils/numberUtils';
interface UsageProgressBarProps {
    used: number;
    total: number;
    label?: string;
    size?: 'sm' | 'lg';
    showLabel?: boolean;
}
type MeterVariant = 'positive' | 'notice' | 'negative';
function getVariant(used: number, total: number): MeterVariant {
    if (total === 0) return 'negative';
    const pct = (used / total) * 100;
    if (pct >= 80) return 'negative';
    if (pct >= 50) return 'notice';
    return 'positive';
}
export const UsageProgressBar: React.FC<UsageProgressBarProps> = ({ used, total, label, size = 'sm', showLabel = false })=>{
    const { t } = useTranslation();
    const pct = total > 0 ? Math.round((used / total) * 100) : 0;
    const variant = getVariant(used, total);
    const ariaLabel = label ?? t('components.usageProgressBar.ariaLabel', {
        used: formatCount(used),
        total: formatCount(total)
    });
    const meterSize = size === 'lg' ? 'L' : 'S';
    if (showLabel && label) {
        return (<div className={" sd171 eb171 Ue171 qe171 _ub171 _vb171 _sb171"}>
        <Meter aria-label={ariaLabel} value={pct} variant={variant} size={meterSize} UNSAFE_style={{
            flex: 1
        }}/>
        <Text>{label}</Text>
      </div>);
    }
    return (<Meter aria-label={ariaLabel} value={pct} variant={variant} size={meterSize} styles={" Za171"}/>);
};

import "macro-1a4167adaf28fe637eaa1980f9a34fa8964471dadd594eca120c303d6e4c5e36.css";
import "macro-2af0af3db39e823eecbe2179b7dbb30d92c11ddd6b0720dbf28502ac6c84b5fa.css";